import ObjectToQueryString from "utils/ObjectToQueryString";
import * as actions from "./actionTypes";
import * as config from "config";


export function selectRecurringTransfer(payload) {
    return {
        type: actions.SELECT_RECURRING_TRANSFER,
        payload
    }
}

export function clearRecurringTransferForm() {
    return {
        type: actions.CLEAR_RECURRING_TRANSFER_FORM,
    }
}

export function saveRecurringTransferForm(payload) {
    return {
        type: actions.SAVE_RECURRING_TRANSFER_FORM,
        payload
    }
}

export function deleteRecurringTransfer(id){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: `${config.apiDeleteUpdateRecurringTransfer}${id}`,
            method: "delete",
            data: {},
            onStart: actions.DELETE_RECURRING_TRANSFER_START,
            onSuccess: actions.DELETE_RECURRING_TRANSFER_DONE,
            onError: actions.DELETE_RECURRING_TRANSFER_FAILED,
        },
    }
}

export function updateRecurringTransfer({id, payload}){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: `${config.apiDeleteUpdateRecurringTransfer}${id}`,
            method: "patch",
            data: {payload},
            onStart: actions.UPDATE_RECURRING_TRANSFER_START,
            onSuccess: actions.UPDATE_RECURRING_TRANSFER_DONE,
            onError: actions.UPDATE_RECURRING_TRANSFER_FAILED,
        },
    }
}

export function pauseRecurringTransfer(payload){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: `${config.apiToggleRecurringTransfer}/${payload?.id}`,
            method: "patch",
            data: {status: payload?.status},
            onStart: actions.PAUSE_RECURRING_TRANSFER_START,
            onSuccess: actions.PAUSE_RECURRING_TRANSFER_DONE,
            onError: actions.PAUSE_RECURRING_TRANSFER_FAILED,
        },
    }
}

export function getRecurringTransferHistory(payload){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiGetEarnipayBeneficiaries,
            method: "get",
            data: {},
            onStart: actions.GET_RECURRING_TRANSFER_HISTORY_START,
            onSuccess: actions.GET_RECURRING_TRANSFER_HISTORY_DONE,
            onError: actions.GET_RECURRING_TRANSFER_HISTORY_FAILED,
        },
    }
}

export function getRecurringTransferDetails(payload){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiGetEarnipayBeneficiaries,
            method: "get",
            data: {},
            onStart: actions.GET_RECURRING_TRANSFER_DETAILS_START,
            onSuccess: actions.GET_RECURRING_TRANSFER_DETAILS_DONE,
            onError: actions.GET_RECURRING_TRANSFER_DETAILS_FAILED,
            useEncryption: true,
        },
    }
}

export function createRecurringTransfer(payload){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiCreateGetRecurringTransfers,
            method: "post",
            data: payload,
            onStart: actions.CREATE_RECURRING_TRANSFER_START,
            onSuccess: actions.CREATE_RECURRING_TRANSFER_DONE,
            onError: actions.CREATE_RECURRING_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function getAllRecurringTransfers(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiCreateGetRecurringTransfers + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_ALL_RECURRING_TRANSFERS_START,
            onSuccess: actions.GET_ALL_RECURRING_TRANSFERS_DONE,
            onError: actions.GET_ALL_RECURRING_TRANSFERS_FAILED,
        },
    }
}

export function resetTransferProperties(payload) {
    return {
        type: actions.RESET_TRANSFER_PROPERTIES,
        payload
    }
}

export function createTransferBeneficiary(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiCreateTransferBeneficiary,
            method: "post",
            data: params,
            onStart: actions.CREATE_TRANSFER_BENEFICIARY_START,
            onSuccess: actions.CREATE_TRANSFER_BENEFICIARY_DONE,
            onError: actions.CREATE_TRANSFER_BENEFICIARY_FAILED,
            useEncryption: true
        },
    }
}

export function getTransferBeneficiaries(){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiGetTransferBeneficiaries,
            method: "get",
            data: {},
            onStart: actions.GET_TRANSFER_BENEFICIARIES_START,
            onSuccess: actions.GET_TRANSFER_BENEFICIARIES,
            onError: actions.GET_TRANSFER_BENEFICIARIES_FAILED,
            useEncryption: true
        },
    }
}

export function createTransferBeneficiaryMultiple(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiCreateMultipleEarnipayBeneficiaries,
            method: "post",
            data: params,
            onStart: actions.CREATE_TRANSFER_BENEFICIARY_START,
            onSuccess: actions.CREATE_TRANSFER_BENEFICIARY_DONE,
            onError: actions.CREATE_TRANSFER_BENEFICIARY_FAILED,
        },
    }
}

export function initiateBulkBankTransfer(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiInitiateBankBulkTransfer,
            method: "post",
            data: params,
            onStart: actions.INITIATE_BANK_TRANSFER_START,
            onSuccess: actions.INITIATE_BANK_TRANSFER_DONE,
            onError: actions.INITIATE_BANK_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function initiateMultipleBankTransfer(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiInitiateMultipleBankTransfer,
            method: "post",
            data: params,
            onStart: actions.INITIATE_BANK_TRANSFER_START,
            onSuccess: actions.INITIATE_BANK_TRANSFER_DONE,
            onError: actions.INITIATE_BANK_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function initiateSingleBankTransfer(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiInitiateSingleBankTransfer,
            method: "post",
            data: params,
            onStart: actions.INITIATE_BANK_TRANSFER_START,
            onSuccess: actions.INITIATE_BANK_TRANSFER_DONE,
            onError: actions.INITIATE_BANK_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function initiateBulkEarnipayTransfer(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiInitiateEarnipayBulkTransfer,
            method: "post",
            data: params,
            onStart: actions.INITIATE_EARNIPAY_TRANSFER_START,
            onSuccess: actions.INITIATE_EARNIPAY_TRANSFER_DONE,
            onError: actions.INITIATE_EARNIPAY_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function initiateMultipleEarnipayTransfer(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiInitiateEarnipayMultipleTransfer,
            method: "post",
            data: params,
            onStart: actions.INITIATE_EARNIPAY_TRANSFER_START,
            onSuccess: actions.INITIATE_EARNIPAY_TRANSFER_DONE,
            onError: actions.INITIATE_EARNIPAY_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function initiateSingleEarnipayTransfer(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: config.apiInitiateEarnipaySingleTransfer,
            method: "post",
            data: params,
            onStart: actions.INITIATE_EARNIPAY_TRANSFER_START,
            onSuccess: actions.INITIATE_EARNIPAY_TRANSFER_DONE,
            onError: actions.INITIATE_EARNIPAY_TRANSFER_FAILED,
            useEncryption: true,
        },
    }
}

export function resetBankTransfer(){
    return {
        type: actions.INITIATE_EARNIPAY_TRANSFER_RESET,
        payload: null,
    }
}

export function bankTransferReset(){
    return {
        type: actions.INITIATE_BANK_TRANSFER_RESET,
        payload: null,
    }
}

export function resetEarnipayTransfer(){
    return {
        type: actions.INITIATE_EARNIPAY_TRANSFER_RESET,
        payload: null,
    }
}

export function saveEarnipayTransferBulkCsv(payload) {
    return {
        type: actions.SAVE_EARNIPAY_TRANSFER_BULK_CSV,
        payload
    }
}

export function saveEarnipayransferBulkCsvErrors(payload) {
    return {
        type: actions.SAVE_EARNIPAY_TRANSFER_BULK_CSV_ERRORS,
        payload
    }
}

export function saveEarnipayPreviewItems(payload) {
    return {
        type: actions.SAVE_EARNIPAY_MULTIPLE_ITEMS,
        payload
    }
}

export function clearEarnipayPreviewItems(payload) {
    return {
        type: actions.CLEAR_EARNIPAY_MULTIPLE_ITEMS,
        payload
    }
}

export function saveBankrTansferPreviewItems(payload) {
    return {
        type: actions.SAVE_BANK_TRANSFER_MULTIPLE_ITEMS,
        payload
    }
}

export function clearBankTransferPreviewItems(payload) {
    return {
        type: actions.CLEAR_BANK_TRANSFER_MULTIPLE_ITEMS,
        payload
    }
}

export function saveBankransferBulkCsv(payload) {
    return {
        type: actions.SAVE_BANK_TRANSFER_BULK_CSV,
        payload
    }
}

export function saveBankransferBulkCsvErrors(payload) {
    return {
        type: actions.SAVE_BANK_TRANSFER_BULK_CSV_ERRORS,
        payload
    }
}

export function deleteTransferBeneficiary(id){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl,
            url: `${config.apiDeleteTransferBeneficiaries}/${id}`,
            method: "delete",
            data: {},
            onStart: actions.DELETE_TRANSFER_BENEFICIARY_START,
            onSuccess: actions.DELETE_TRANSFER_BENEFICIARY,
            onError: actions.DELETE_TRANSFER_BENEFICIARY_FAILED,
            useEncryption: true
        },
    }
}

export function resetDeleteTransferBeneficiary(payload) {
    return {
        type: actions.DELETE_TRANSFER_BENEFICIARY_RESET,
        payload
    }
}

export function resetCreateTransferBeneficiary(payload) {
    return {
        type: actions.CREATE_TRANSFER_BENEFICIARY_RESET,
        payload
    }
}